export default __webpack_public_path__ + "static/media/CarrerDevelopment.3ce5f5f0.svg";